<template>
  <div class="progressbar__wrapper d-none d-xl-block">
    <div class="position-relative">
      <div class="progressbar__countdown" v-show="showPuff">
        <div class="progressbar__countdown--missing">Jeszcze</div>
        <div class="progressbar__countdown--number">{{ countdown }}!</div>
      </div>
      <b-progress :max="max">
        <b-progress-bar :value="value"> </b-progress-bar>
        <span
          class="progressbar__info"
          v-if="showBee"
          v-bind:style="styleObject"
        >
          <span class="progressbar__counter">{{ value }}</span>
          <img
            class="progressbar__bee"
            src="../assets/images/bees/bee__1.svg"
            alt="Pszczółka"
        /></span>
      </b-progress>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: { counterData: Number },
  data() {
    return {
      value: 0,
      max: 125000,
      showProgresBar: false,
      showBee: false,
      showPuff: false,
      countdown: "",
      styleObject: {
        left: "0px",
      },
    };
  },
  created() {
    
    this.delayedShow();
  },
  methods: {
    delayedShow() {
      let delay = 1500;
      setTimeout(() => {
        this.showProgresBar = false;
      }, delay);
      setTimeout(() => {
        this.value = this.counterData;
      }, 1500);
      setTimeout(() => {
        this.countPosition();
        this.showBee = true;
        this.countCountdown();
      }, 10000);
      setTimeout(() => {
        this.showPuff = true;
      }, 11000);
      setTimeout(() => {
        this.showPuff = false;
      }, 16000);
    },
    countPosition: function() {
      if (this.max >= this.counterData) {
        this.styleObject.left = (this.counterData / this.max) * 95 + "%";
      } else {
        this.styleObject.left = 98 + "%";
      }
    },
    countCountdown: function() {
      if (this.value < this.max) {
        this.countdown = (this.max - this.value)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      } else {
        this.countdown = "0";
      }
    },
  },
};
</script>
